export default [
     {
          path: '/classified-content',
          name: 'ClassifiedContent',
          component: () => import("@/views/Page/ClassifiedContent/ClassifiedContent.vue"),
           meta: {
               title: 'Classified Content',
          },
     }
];

